import { Divider, styled } from '@mui/material';

export const FormDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0),
}));
